import { render, staticRenderFns } from "./BaseDataRange.vue?vue&type=template&id=6da6f576"
import script from "./BaseDataRange.vue?vue&type=script&lang=js"
export * from "./BaseDataRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports